module.exports = __webpack_public_path__ + "img/bg.fef1c145.jpg";